import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AuthorizeService } from 'src/app/_core/access-control/authorize.service';
import { UserState } from 'src/app/_shared/state/user.state';
import { AppState } from 'src/app/app.state';
import constants from 'src/constant.json';
import { ClientDashboardService } from '../../../service/client-dashboard.service';
import { ClientDashboardState } from '../../../state/client-dashboard.state';

@Component({
  selector: 'app-partner-dashboard',
  templateUrl: './partner-dashboard.component.html',
  styleUrls: ['./partner-dashboard.component.scss'],
})
export class PartnerDashboardComponent implements OnInit {
  isDataLoading: boolean = false;
  partnershipDetails = [];
  @ViewChild('inviteAgentDialog', { static: true }) inviteAgentDialog: any;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  dialogRef: any;
  agentInviteForm: FormGroup;
  canViewLoanOfficer: boolean;
  isLoanOfficer: boolean = false;
  loadEmailTemplate: boolean = false;
  htmlData: any;
  userRole: string;
  source: string;
  onDestroyNotifier$ = new Subject();
  portFolioUrl: any;
  baseUrl: string;
  pageIndex: number;
  activePartnersCount: number;
  pageSizeOptions = [12, 24];
  Math: Math = Math;
  sanitizedHtml: string;
  isValueTestCompany: boolean = false;
  allReferrals: boolean = false;
  isProgress:any;

  investorFetchParams = { orderBy: 'createdDate', orderType: 'desc', limit: 12, offset: 0, allReferrals: false };
  inviteUserType: string = 'Agent';
  partnerFilterForm: FormGroup = this.formBuilder.group({
    userType: [''],
    source: [''],
    userNameOrEmail: [''],
  });
  displayValues: any;
  exportingInProgress: boolean;
  constructor(
    private clientDashboardService: ClientDashboardService,
    public clientDashboardState: ClientDashboardState,
    private dialog: MatDialog,
    public formBuilder: FormBuilder,
    public authorizeService: AuthorizeService,
    private userState: UserState,
    public appState: AppState,
    private activatedRoute: ActivatedRoute
  ) {}

  ngOnInit(): void {
    if (this.appState.companyInfoValue.appConfig?.valueReport?.isEnabled) {
      this.isValueTestCompany = true;
    }
    this.fetchActivePartners();
    this.userState.userDetail$.pipe(takeUntil(this.onDestroyNotifier$)).subscribe((res) => {
      if (res) {
        this.canViewLoanOfficer = this.authorizeService.canView('inviteAgent');
        if (res?.roles?.length > 0) {
          this.userRole = res.roles[0];
          this.source = res.utm_source;
          if (this.userRole == 'loanOfficer') this.isLoanOfficer = true;
        }
      }
    });
    const queryParams = { ...this.activatedRoute.snapshot.queryParams };
      if(queryParams.redirectTo == 'partners' && this.userRole == 'loanOfficer' && queryParams.openDialog == 'true'){
        this.openInviteDialogBox('Agent');
      }
    this.clientDashboardState.activePartnersCount$.pipe(takeUntil(this.onDestroyNotifier$)).subscribe((count) => {
      this.activePartnersCount = count;
    });
    this.displayValues = constants.USERTYPE_DISPLAY_VALUES;
    this.baseUrl = this.appState.companyInfoValue.baseUrl;
    this.portFolioUrl = `https://${this.baseUrl}/portfolio/`;

    this.clientDashboardState.activePartnerList$
      .pipe(takeUntil(this.onDestroyNotifier$))
      .subscribe((partnershipList: any) => {
        // if (this.appState?.companyInfoValue.appConfig?.valueReport?.isEnabled) {
        //   this.partnershipDetails = partnershipList.filter((record) => { return !record.isDefaultPartner });
        // } else {
        this.partnershipDetails = partnershipList;
        // }
      });

    this.agentInviteForm = this.formBuilder.group({
      firstName: [
        '',
        Validators.compose([Validators.maxLength(25), Validators.pattern('[a-zA-Z ]*'), Validators.required]),
      ],
      lastName: ['', Validators.pattern('[a-zA-Z ]*')],
      email: ['', [Validators.required, Validators.pattern(constants.regex.validEmail)]],
      phone: ['', Validators.pattern('^(\\+\\d{1,2}\\s?)?1?\\-?\\.?\\s?\\(?\\d{3}\\)?[\\s.-]?\\d{3}[\\s.-]?\\d{4}$')],
    });

    // this.partnerFilterForm.get('userType').valueChanges.subscribe((userType) => {
    //   if (userType) {
    //     this.investorFetchParams['userType'] = userType;
    //     this.setPaginationToBeginning();
    //   } else {
    //     this.investorFetchParams['userType'] = null;
    //     this.setPaginationToBeginning();
    //   }
    // });
    // this.partnerFilterForm.get('source').valueChanges.subscribe((source) => {
    //   if (source) {
    //     this.investorFetchParams['source'] = source;
    //     this.setPaginationToBeginning();
    //   } else {
    //     this.investorFetchParams['source'] = null;
    //     this.setPaginationToBeginning();
    //   }
    // });
    // this.partnerFilterForm.get('userNameOrEmail').valueChanges.subscribe((userNameOrEmail) => {
    //   if (userNameOrEmail) {
    //     this.investorFetchParams['userNameOrEmail'] = userNameOrEmail;
    //     this.setPaginationToBeginning();
    //   } else {
    //     this.investorFetchParams['userNameOrEmail'] = null;
    //     this.setPaginationToBeginning();
    //   }
    // });
  }

  readyToExport() {
    this.exportingInProgress = true;
    this.investorFetchParams['format'] = 'csv';
    this.clientDashboardService
      .fetchActivePartners(this.investorFetchParams)
      .pipe(takeUntil(this.onDestroyNotifier$))
      .subscribe((res) => {
        if (res && res.data) {
          let delimitedText = res.data.data.referralsList;
          let csvName = res.data.data.csvName ? res.data.data.csvName + '.csv' : 'referrals.csv';
          let csvData = new Blob([delimitedText], {
            type: 'text/csv;charset=utf-8;',
          });
          let csvURL = window.URL.createObjectURL(csvData);
          let downloadFile = document.createElement('a');
          downloadFile.href = csvURL;
          downloadFile.setAttribute('download', csvName);
          downloadFile.click();
          this.investorFetchParams['format'] = null;
          this.exportingInProgress = false;
        }
      });
  }

  getMappedUserType(userType: string): string {
    return this.displayValues[userType] || userType;
  }

  setPaginationToBeginning() {
    this.paginator.pageIndex = 0;
    this.investorFetchParams.offset = 0;
    this.fetchActivePartners();
  }

  filter() {
    if (this.partnerFilterForm.get('userType').value) {
      this.investorFetchParams['userType'] = this.partnerFilterForm.get('userType').value;
    } else {
      this.investorFetchParams['userType'] = null;
    }
    if (this.partnerFilterForm.get('source').value) {
      this.investorFetchParams['source'] = this.partnerFilterForm.get('source').value;
    } else {
      this.investorFetchParams['source'] = null;
    }
    if (this.partnerFilterForm.get('userNameOrEmail').value) {
      this.investorFetchParams['userNameOrEmail'] = this.partnerFilterForm.get('userNameOrEmail').value;
    } else {
      this.investorFetchParams['userNameOrEmail'] = null;
    }
    this.investorFetchParams['format'] = null;
    this.setPaginationToBeginning();
  }

  processHtml(html: string, subject: string) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');

    const links = doc.querySelectorAll('a');
    links.forEach((link) => {
      link.removeAttribute('href');
      link.style.pointerEvents = 'none';
      link.style.color = 'blue';
      link.style.textDecoration = 'none';
    });

    const images = doc.querySelectorAll('img');
    images.forEach((img) => {
      img.remove();
    });

    const subjectLine = document.createElement('h3');
    subjectLine.textContent = `Subject: ${subject}`;
    doc.body.insertBefore(subjectLine, doc.body.firstChild);

    const wrapperDiv = document.createElement('div');
    wrapperDiv.classList.add('invite-invitation');
    wrapperDiv.innerHTML = doc.body.innerHTML;
    doc.body.innerHTML = wrapperDiv.outerHTML;

    return doc.body.innerHTML;
  }

  fetchEmailTemplate() {
    if (this.agentInviteForm.invalid) {
      return;
    }

    const formData = this.agentInviteForm.value;
    let agentInfo = {
      email: formData.email.toLowerCase(),
      firstName: formData.firstName,
      lastName: formData.lastName,
      phone: formData.phone,
      subject: '',
    };
    if (this.userRole === 'loanOfficer') {
      agentInfo.subject =
        this.source === 'compCheck'
          ? constants.EMAIL_TEMPLATE.agent_new_agent_invitation_by_compcheck_loan_officer
          : constants.EMAIL_TEMPLATE.agent_new_agent_invitation_by_loan_officer;
    }

    this.clientDashboardService
      .fetchEmailTemplate(agentInfo)
      .pipe(takeUntil(this.onDestroyNotifier$))
      .subscribe(
        (res: any) => {
          if (res && res.data) {
            this.sanitizedHtml = this.processHtml(res.data.emailContent, res.data.subject);
            this.htmlData = this.sanitizedHtml;
            this.loadEmailTemplate = true;
          }
        },
        (error) => {
          console.log(error);
        }
      );
  }

  fetchActivePartners() {
    this.clientDashboardService
      .fetchActivePartners(this.investorFetchParams)
      .pipe(takeUntil(this.onDestroyNotifier$))
      .subscribe((res: any) => {
        this.isDataLoading = res.isLoading;
      });
  }


  acceptInvitation(partner: any) {
    const params = {
       partnerId : partner.partnerId,
       connectionId : partner.connectionId
    }
 this.clientDashboardService
      .partnerAcceptInvitation(params)
     .pipe(takeUntil(this.onDestroyNotifier$))
      .subscribe((res: any) => {
        this.isProgress = res.isLoading;
        this.investorFetchParams = { orderBy: 'createdDate', orderType: 'desc', limit: 12, offset: 0, allReferrals: false };
         this.fetchActivePartners();
      });
}


  setAsDefaultPartner(connectionId) {
    this.clientDashboardService
      .setAsDefaultPartner({
        connId: connectionId,
      })
      .pipe(takeUntil(this.onDestroyNotifier$))
      .subscribe((res: any) => {
        this.fetchActivePartners();
      });
  }

  pageChange(event) {
    let params = {
      limit: event.pageSize,
      offset: event.pageSize * event.pageIndex,
    };
  }

  getAllReferrals() {
    this.investorFetchParams.limit = 12;
    this.investorFetchParams.offset = 0;
    this.allReferrals = !this.allReferrals;
    if (this.allReferrals == true) {
      this.investorFetchParams.allReferrals = true;
    } else {
      this.investorFetchParams.allReferrals = false;
    }
    if (this.paginator) {
      this.paginator.firstPage();
    }
    this.fetchActivePartners();
  }

  onPartnersPageChange(event) {
    if (this.investorFetchParams.offset != event.pageSize * event.pageIndex) {
      this.investorFetchParams.limit = event.pageSize;
      this.investorFetchParams.offset = event.pageSize * event.pageIndex;
    } else {
      this.investorFetchParams.limit = event.pageSize;
      this.paginator.pageIndex = 0;
      this.investorFetchParams.offset = 0;
    }
    this.fetchActivePartners();
  }

  ngOnDestroy() {
    this.onDestroyNotifier$.next();
    this.onDestroyNotifier$.complete();
  }

  openInviteDialogBox(inviteUserType) {
    this.inviteUserType = inviteUserType;
    this.dialogRef = this.dialog.open(this.inviteAgentDialog);
  }

  closeDialog() {
    this.agentInviteForm.reset();
    this.dialogRef.close();
    this.loadEmailTemplate = false;
  }

  hideEmailTemplate(event) {
    this.loadEmailTemplate = false;
  }
  inviteUser() {
    if (this.agentInviteForm.invalid) {
      return;
    }
    const formData = this.agentInviteForm.value;
    const inviteInfo = {
      email: formData.email.toLowerCase(),
      firstName: formData.firstName,
      lastName: formData.lastName,
      phone: formData.phone,
      type:
        this.inviteUserType == 'Loan Officer'
          ? 'loanOfficer'
          : this.inviteUserType == 'Appraiser'
          ? 'appraiser'
          : 'agent',
      method: 'invitation',
    };
        this.investorFetchParams = { orderBy: 'createdDate', orderType: 'desc', limit: 12, offset: 0, allReferrals: false };
    if (this.inviteUserType == 'Loan Officer') {
      this.clientDashboardService
        .inviteLoanOfficer(inviteInfo)
        .pipe(takeUntil(this.onDestroyNotifier$))
        .subscribe((res: any) => {
           this.handleInviteSuccess();
        });
    } else if (this.inviteUserType == 'Appraiser') {
      this.clientDashboardService
        .inviteAppraiser(inviteInfo)
        .pipe(takeUntil(this.onDestroyNotifier$))
        .subscribe((res: any) => {
           this.handleInviteSuccess();
        });
    } else {
      this.clientDashboardService
        .inviteUser(inviteInfo)
        .pipe(takeUntil(this.onDestroyNotifier$))
        .subscribe((res: any) => {
     this.handleInviteSuccess();
        });
    }
    this.loadEmailTemplate = false;
  }

  get formControls() {
    return this.agentInviteForm.controls;
  }


   shouldFetchReferrals(): boolean {
  return (
    (this.appState?.companyInfoValue.appConfig?.valueReport?.isEnabled &&
      this.userRole === 'companyManager') ||
    this.userRole === 'companyEmployee'
  );
}

private handleInviteSuccess(): void {
  this.agentInviteForm.reset();
  this.dialogRef.close();

  if (this.shouldFetchReferrals()) {
    this.getAllReferrals();
  } else {
    this.fetchActivePartners();
  }
}

  restrictAlphabets(event) {
    var inp = String.fromCharCode(event.keyCode);
    if (/[0-9]/.test(inp)) {
      return true;
    } else {
      event.preventDefault();
      return false;
    }
  }

  reset() {
    this.investorFetchParams = { orderBy: 'createdDate', orderType: 'desc', limit: 12, offset: 0, allReferrals: false };
    this.partnerFilterForm.reset();
    if (this.paginator) {
      this.paginator.firstPage();
    }
    this.fetchActivePartners();
  }
}
